import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import EnhancedRegistrationForm from "@/components/auth/registration/EnhancedRegistrationForm";
const RegisterPage = () => {
  return <Card className="w-full max-w-2xl border-border bg-card animate-fade-in-stable">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl font-bold text-center">Create Your GoDyspo Account</CardTitle>
        <CardDescription className="text-center">Join the movement and start your 30-day free trial!</CardDescription>
      </CardHeader>
      <CardContent>
        <EnhancedRegistrationForm />
      </CardContent>
    </Card>;
};
export default RegisterPage;